/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Optout_AInputs */



/**
* | output |
* | --- |
* | "No. /opt-out erases everything recorded about them in that server, their XP, level and imports included, and while levelling is on it takes their perk roles ..." |
*
* @param {Products_Leveling_Faq_Optout_AInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_optout_a = /** @type {((inputs?: Products_Leveling_Faq_Optout_AInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Optout_AInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет. /не-учитывать-меня стирает всё, что было записано о нём на этом сервере, включая XP, уровень и импорт, а пока уровни включены, ещё и снимает с него роли-привилегии.")
	return /** @type {LocalizedString} */ ("No. /opt-out erases everything recorded about them in that server, their XP, level and imports included, and while levelling is on it takes their perk roles off them.")
});